import { FC, useEffect, useState } from 'react';

import { NavigationItem } from '@telialt/models/src/Navigation';

import { getB2bUrl } from '../../utils/path';
import { MobileMenuItemLink } from '../MobileMenu/MobileMenuItemLink';
import { MobileMenuItemComponentSkeleton } from './MobileMenuItemComponentSkeleton';

type Props = {
    item: NavigationItem;
    menuLevel: number;
};

export const MobileMenuItemComponentB2b: FC<Props> = ({ item, menuLevel }) => {
    const [isMounted, setIsMounted] = useState(false);

    useEffect(() => {
        setIsMounted(true);
    }, []);

    if (!isMounted) {
        return <MobileMenuItemComponentSkeleton />;
    }

    return <MobileMenuItemLink item={{ ...item, url: getB2bUrl(item.url) }} menuLevel={menuLevel} />;
};
